import CommonRouterSection from '@/components/layout/CommonRouterSection'

export default {
  path: '/signin',
  name: 'signin',
  component: CommonRouterSection,
  children: [
    {
      path: '/signin',
      name: 'signin-index',
      component: () => import('@/views/signin/SignIn.vue')
    },
    {
      path: 'strongauth/:strong_auth_type_code',
      name: 'strong-auth-index',
      component: () => import('@/views/signin/StrongAuth.vue')
    },
    {
      path: 'strongauth/:strong_auth_type_code/:return_url',
      name: 'strong-auth-index-return',
      component: () => import('@/views/signin/StrongAuth.vue')
    },
    {
      path: 'forgotaccount',
      name: 'forget-account-index',
      component: () => import('@/views/signin/ForgotAccount.vue')
    },
    {
      path: 'resetpassword/:hash_key',
      name: 'reset-password-index',
      component: () => import('@/views/signin/ResetPassword.vue')
    },
    {
      path: 'resetgoogleotp/:hash_key',
      name: 'reset-googleotp-index',
      component: () => import('@/views/signin/ResetGoogleOtp.vue')
    },
    {
      path: 'setpassword',
      name: 'set-password-index',
      component: () => import('@/views/signin/SetPassword.vue')
    },
    {
      path: 'setpassword/*',
      name: 'setpassword-index',
      component: () => import("@/views/signin/SetPassword.vue")
    },
    {
      path: 'proofdocument',
      name: 'proofdocument-index',
      component: () => import("@/views/signin/ProofDocument.vue")
    },
    {
      path: 'resetpincode/:hash_key',
      name: 'resetpincode-index',
      component: () => import("@/views/signin/ResetPinCode.vue")
    },
    {
      path: 'proof/:hash_key',
      name: 'proof-index',
      component: () => import("@/views/signin/ProofOfDocument.vue")
    }
  ]


}
